export const isPostTitleDimmed = ({
  type,
  isPostSeen,
}: {
  type: 'postPage' | 'footerPost' | 'recentPostsWidget';
  isPostSeen: boolean;
}) => {
  if (type === 'postPage') {
    return false;
  }

  return isPostSeen;
};
